import type { GameStatus } from '@wx-weiqi/contracts';

interface ScoringSubmissions {
  readonly blackAt: string | null;
  readonly whiteAt: string | null;
}

export function revealAuthoritativeScoringResult(
  status: GameStatus,
  submittedBy: ScoringSubmissions | null | undefined,
): boolean {
  return status === 'FINISHED' || (submittedBy?.blackAt != null && submittedBy.whiteAt != null);
}

export function scoringConfirmationLabel(confirmed: boolean): string {
  return confirmed ? '已确认结果' : '确认结果';
}

export function shouldClearScoringDraft(
  status: GameStatus | null | undefined,
  myMarksSubmitted: boolean,
): boolean {
  return status !== 'SCORING' || myMarksSubmitted;
}
